import styled from "@emotion/styled"
import { V2L1StatusIndicator } from "./V2L1StatusIndicator"
import { ValiditySeverity } from "@fusion-advantage/formlib"
import { validitySeverityIndicatorProps } from "./StatusIndicatorProps"

const StatusIndicator = styled(V2L1StatusIndicator)({
	fontSize: `${12/16}rem`,
})

interface V2L1FieldValidityCaptionProps {
	severity: ValiditySeverity
	title: string
}

export const V2L1FieldValidityCaption = ({severity, title}: V2L1FieldValidityCaptionProps) => {
	return (
		<StatusIndicator
			{...validitySeverityIndicatorProps(severity)}
			title={title}
			coloredLabel
		/>
	)
}
